import React, { useState, useEffect } from "react";
import styled from "styled-components";
import HeaderComponents from "../../Components/HeaderComponent";
import { Container } from "../../Components/StyledComponents/StyledComponents";
import InfoSection from "./InfoSection";
import Card from "./Card";
const InfoIcon        = `${environmentVariables?.cdnUrl}infogrey.png`
const bgImage         = `${environmentVariables?.cdnUrl}Hammer_character.png`
const SmartIcon       = `${environmentVariables?.cdnUrl}smartIcon.png`
const CirculationIcon = `${environmentVariables?.cdnUrl}circulation.png`
const TotalstakeIcon  = `${environmentVariables?.cdnUrl}Total_stake.png`
const MLDIcon         = `${environmentVariables?.cdnUrl}MLD.png`

import { ethers } from "ethers";
import {
  getminMLD,
  getBaseAPY,
  getUnstakeLordFeesPercentage,
  getLordRatio,
  getPreMatureMLDPenalty,
  getUserLatestId,
  getTotalMLDLocked,
  getUserTotalDeposits,
  getDurationwiseStake,
} from "./contractData";
import { mldStakingAddress } from "../../config/data";
import { balanceOf, checkAllowance } from "../../config/provider";
import environmentVariables from "../../config/environmentVariables";
import axios from "axios";

const Root = styled.div``;
const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(p) => p.theme.spacing.sm};
  @media (max-width: ${(p) => p.theme.screen.sm}) {
    flex-direction: column;
  }
`;
const Div = styled.div`
  width: calc(50% - 20px);
  @media (max-width: ${(p) => p.theme.screen.sm}) {
    width: 100%;
  }
`;

const ImageWrapper = styled.div`
  width: calc(50% - 20px);
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: ${(p) => p.theme.screen.sm}) {
    /* display: none; */
  }
`;
const Image = styled.img`
  width: fit-content;
  height: fit-content;
  max-height: 600px;
  @media (max-width: 768px) {
    max-height: 400px;
    padding: 20px;
  }
  @media (max-width: 1024px) {
    max-height: 400px;
    padding: 20px;
  }
`;
const HeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 1024px) {
    margin: 20px 0 10px 0;
  }
  @media (max-width: 768px) {
    padding-top: 20px;
  }
`;
const Icon = styled.img`
  width: 30px;
  height: 30px;
  @media (min-width: 1600px) {
  }
`;
const Heading = styled.div`
  font-size: ${(p) => p.theme.font.size.lg};
  font-weight: ${(p) => p.theme.font.weight.bolder};
  font-family: ${(p) => p.theme.font.family.SweraDemo};
  @media (min-width: 1600px) {
    font-size: ${(p) => p.theme.font.size.xl};
  }
  @media (max-width: ${(p) => p.theme.screen.xxs}) {
    font-size: ${(p) => p.theme.font.size.md};
  }
`;
const IconWrapper = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1c2122;
  margin-right: 20px;
  @media (max-width: 768px) {
  }
`;
const Text = styled.div`
  color: ${(p) => p.theme.colors.lightskytextcolor};
  margin-top: ${(p) => p.theme.spacing.xs};
  @media (min-width: 1600px) {
    font-size: ${(p) => p.theme.font.size.lg};
  }
`;

const StakeContainer = styled.div`
  margin: 1rem 0 6rem 0;
  @media (max-width: 768px) {
    margin: 1rem 0 30px 0;
  }
  @media (max-width: 1024px) {
    margin: 1rem 0 30px 0;
  }
`;

const CardWrapperContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column;
  }
  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

const CardWrapper = styled.div`
  width: calc(50% - 20px);
  position: relative;

  display: flex;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 0;
  }
  @media (max-width: 1024px) {
    width: 100%;
    margin-bottom: 0;
  }
`;

const Farm = (props) => {
  const { allContractDetails, setAllContractDetails } = props;
  const [defaultAccount, setDefaultAccount] = useState(null);
  const [userBalance, setUserBalance] = useState({
    MLDBalance: 0,
    LORDBalance: 0,
    MLD: 0,
    LORD: 0,
  });
  const [minMld, setMinMLD] = useState(0);
  const [apy, setApy] = useState(0);
  const [infoOpen, setInfoOpen] = useState(false);
  const [apyinfoOpen, setApyinfoOpen] = useState(false);
  const [finalApyData, setFinalApyData] = useState([]);
  const [totalMLDStaked, setTotalMLDStaked] = useState(0);
  const [totalMLDLocked, setTotalMLDLocked] = useState(0);
  const [unstakeLordFeesPercentage, setUnstakeLordFeesPercentage] =
    useState(null);
  const [lordRatio, setLordRatio] = useState(null);
  const [preMatureMLDPenalty, setPreMatureMLDPenalty] = useState(null);
  // const [userDeposits, setUserDeposits] = useState([]);
  const [allowance, setAllowance] = useState({
    MLDAllowance: 0,
    LORDAllowance: 0,
  });
  const [userLatestIndex, setUserLatestIndex] = useState(null);
  const [userTotalDeposit, setUserTotalDeposit] = useState(null);
  const [lordRatioI, setLordRatioI] = useState(false);
  const [immutureNotePopup, setImmutureNotePopup] = useState(false);
  const [minimumMldNotePopup, setMinimumMldNotePopup] = useState(false);
  const [lordFeeNotePopup, setLordFeeNotePopup] = useState(false);
  const monthToSecData = [
    {
      month: 3,
      sec: 7776000,
    },
    {
      month: 6,
      sec: 15552000,
    },
    {
      month: 12,
      sec: 31104000,
    },
  ];

  useEffect(() => {
    if (allContractDetails?.address) {
      getAllTheInformation();
    } else {
      getAllInformationFromAPI();
      setUserBalance({
        MLDBalance: 0,
        LORDBalance: 0,
        MLD: 0,
        LORD: 0,
      });
    }
  }, []);

  useEffect(() => {
    if (allContractDetails?.address) {
      getAllTheInformation();
    } else {
      getAllInformationFromAPI();
    }
  }, [allContractDetails]);

  const clearData = () => {
    setDefaultAccount(null);
    setLordRatio(null);
    setMinMLD(0);
    setApy(0);
    setTotalMLDLocked(0);
    setUnstakeLordFeesPercentage(null);
    setPreMatureMLDPenalty(null);
    setUserBalance({
      MLDAllowance: 0,
      LORDAllowance: 0,
      MLD: 0,
      LORD: 0,
    });
    setAllowance({
      MLDAllowance: 0,
      LORDAllowance: 0,
    });
    setUserTotalDeposit(null);
    setUserLatestIndex(null);
  };

  // console.log("finalApyData", finalApyData);
  const getAllInformationFromAPI = async () => {
    axios
      .get(
        `${environmentVariables?.redisUrl}/nftmarketplace/api/v1/get_mld_staking_data`
      )
      .then((response) => {
        setLordRatio(response?.data?.data?.lordRatio);
        setMinMLD(response?.data?.data?.minMLD);
        setApy(response?.data?.data?.apyNumber);
        setTotalMLDLocked(response?.data?.data?.totalMLDLocked);
        setUnstakeLordFeesPercentage(
          response?.data?.data?.unstakeLordFeesPercentage
        );
        setPreMatureMLDPenalty(response?.data?.data?.prematureMLDPenalty);
        setFinalApyData(response?.data?.data?.apyDataArr);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getAllTheInformation = async () => {
    const address = allContractDetails?.address;
    const apyNumber = await getBaseAPY(allContractDetails?.mldStakingContract);
    let arr = [];
    monthToSecData.map(async (month) => {
      const durWiseStake = await getDurationwiseStake(
        allContractDetails?.mldStakingContract,
        month.sec
      );
      // console.log("durWiseStake", durWiseStake, month);
      if (durWiseStake["valid"] === true) {
        // console.log("inside if");
        const resultInterestRate = Math.round(
          (Number(durWiseStake["multiplier"]) *
            Number(parseFloat(apyNumber)) *
            parseFloat(month.sec / 31104000)) /
            100
        );
        arr.push({
          ...month,
          number: resultInterestRate,
        });
      } else {
        // console.log("inside else");
        arr.push({
          ...month,
          number: Number(durWiseStake["multiplier"]),
        });
      }
      // console.log("arr mld staking", arr);
      setFinalApyData(arr);
    });

    setDefaultAccount(address);
    setLordRatio(await getLordRatio(allContractDetails?.mldStakingContract));
    setMinMLD(await getminMLD(allContractDetails?.mldStakingContract));
    setApy(apyNumber);
    setTotalMLDLocked(
      await getTotalMLDLocked(allContractDetails?.mldStakingContract)
    );
    setUnstakeLordFeesPercentage(
      await getUnstakeLordFeesPercentage(allContractDetails?.mldStakingContract)
    );
    setPreMatureMLDPenalty(
      await getPreMatureMLDPenalty(allContractDetails?.mldStakingContract)
    );

    const mldBal = await balanceOf(
      allContractDetails?.mldTokenContract,
      address
    );
    const lordBal = await balanceOf(
      allContractDetails?.lordTokenContract,
      address
    );

    setUserBalance({
      MLDBalance: parseInt(mldBal),
      LORDBalance: parseInt(lordBal),
      MLD: ethers.utils.formatEther(mldBal),
      LORD: parseInt(ethers.utils.formatEther(lordBal)),
    });

    setAllowance({
      MLDAllowance: parseInt(
        await checkAllowance(
          allContractDetails?.mldTokenContract,
          address,
          mldStakingAddress
        )
      ),
      LORDAllowance: parseInt(
        await checkAllowance(
          allContractDetails?.lordTokenContract,
          address,
          mldStakingAddress
        )
      ),
    });

    try {
      setUserTotalDeposit(
        await getUserTotalDeposits(
          allContractDetails?.mldStakingContract,
          address
        )
      );
    } catch (error) {
      setUserTotalDeposit(null);
    }

    try {
      setUserLatestIndex(
        await getUserLatestId(allContractDetails?.mldStakingContract, address)
      );
    } catch (error) {
      setUserLatestIndex(null);
    }
  };

  // const getEtherInformation = (arr, key) => {
  //   return (
  //     (arr?.length > 0 && arr[key] && ethers.utils.formatEther(arr[key])) || 0
  //   );
  // };

  const LordRatioNoteIconClick = (e) => {
    e.stopPropagation();
    setLordRatioI(!lordRatioI);
    setImmutureNotePopup(false);
    setMinimumMldNotePopup(false);
    setLordFeeNotePopup(false);
  };
  const ImmutureNoteIconClick = (e) => {
    e.stopPropagation();
    setImmutureNotePopup(!immutureNotePopup);
    setLordRatioI(false);
    setMinimumMldNotePopup(false);
    setLordFeeNotePopup(false);
  };
  const MinimumMldNoteIconClick = (e) => {
    e.stopPropagation();
    setMinimumMldNotePopup(!minimumMldNotePopup);
    setLordRatioI(false);
    setImmutureNotePopup(false);
    setLordFeeNotePopup(false);
  };
  const LordFeeNoteIconClick = (e) => {
    e.stopPropagation();
    setLordFeeNotePopup(!lordFeeNotePopup);
    setLordRatioI(false);
    setImmutureNotePopup(false);
    setMinimumMldNotePopup(false);
  };
  return (
    <Root
      onClick={() => {
        setApyinfoOpen(false);
        setInfoOpen(false);
        setMinimumMldNotePopup(false);
        setLordFeeNotePopup(false);
        setLordRatioI(false);
        setImmutureNotePopup(false);
      }}
    >
      <Container>
        <HeaderComponents title="Meta Stake" />
        <Wrapper>
          <Div>
            <HeadingWrapper>
              <IconWrapper>
                {" "}
                <Icon src={SmartIcon} />
              </IconWrapper>
              <Heading>The MLD Staking</Heading>
            </HeadingWrapper>
            <Text>Earn MLD by staking on the Metaspace Network</Text>
            <Card image={CirculationIcon} title="Polygon" data="MLD" />
            <Card
              image={TotalstakeIcon}
              title="Total MLD Staked"
              data={parseFloat(totalMLDStaked).toFixed(2)}
            />
            <Card image={MLDIcon} title="APY" data={`${apy}%` || "10.63%"} />
          </Div>

          <ImageWrapper>
            <Image src={bgImage} />
          </ImageWrapper>
        </Wrapper>

        {/* //////////////////////////////////////////////////////////// */}

        <StakeContainer>
          <CardWrapperContainer>
            <CardWrapper>
              <Card
                image={TotalstakeIcon}
                title="MLD Balance (User)"
                data={parseFloat(userBalance?.MLD || 0).toFixed(2)}
                color1="color1"
              />
            </CardWrapper>
            <CardWrapper>
              <Card
                image={CirculationIcon}
                title="Lord Fee Percentage (Unstaked)"
                data={`${parseFloat(unstakeLordFeesPercentage || 0).toFixed(
                  0
                )}%`}
                color2="color2"
                NoteIcon={InfoIcon}
                onNoteIconClick={LordFeeNoteIconClick}
                isPopUp={lordFeeNotePopup}
                activePopUpText={`MinimumMLD`}
                popUpText={`Lord token fees percentage that would be deducted while
                unstaking tokens`}
              />
            </CardWrapper>
          </CardWrapperContainer>
          <CardWrapperContainer>
            <CardWrapper>
              <Card
                image={SmartIcon}
                title="Minimum MLD"
                NoteIcon={InfoIcon}
                data={parseFloat(
                  parseInt(ethers.utils.formatEther(minMld.toString()) || 0)
                ).toFixed(2)}
                color3="color3"
                onNoteIconClick={MinimumMldNoteIconClick}
                isPopUp={minimumMldNotePopup}
                activePopUpText={`MinimumMLD`}
                popUpText={`Minimum MLD Amount that can be staked`}
              />
            </CardWrapper>
            <CardWrapper>
              <Card
                image={SmartIcon}
                title="Premature Withdrawal Penalty"
                data={`${parseFloat(preMatureMLDPenalty || 0).toFixed(0)}%`}
                color1="color1"
                NoteIcon={InfoIcon}
                onNoteIconClick={ImmutureNoteIconClick}
                isPopUp={immutureNotePopup}
                activePopUpText={`ImmatureWithdrawal`}
                popUpText={`penalty percentage for premature withdrawals of MLD tokens`}
              />
            </CardWrapper>
          </CardWrapperContainer>

          <CardWrapperContainer>
            <CardWrapper>
              <Card
                image={TotalstakeIcon}
                title="LORD Ratio"
                data={`${parseFloat(lordRatio || 0).toFixed(0)}%`}
                color2="color2"
                NoteIcon={InfoIcon}
                onNoteIconClick={LordRatioNoteIconClick}
                isPopUp={lordRatioI}
                activePopUpText={`LORDRatio`}
                popUpText={`Lock percentage of Lord tokens`}
              />
            </CardWrapper>
          </CardWrapperContainer>
        </StakeContainer>

        {/* <table>
          <th>
            <td>month</td>
            <td>Final APY</td>
          </th>
          {
            finalApyData?.map(apy => {
              return(
                <tr>
                  <td>{apy.month}</td>
                  <td>{apy.number}</td>
                </tr>
              )
            })
          }
        </table> */}
        {/* ///////////////////////////////////////////////////////////// */}

        <InfoSection
          {...props}
          allContractDetails={allContractDetails}
          setAllContractDetails={setAllContractDetails}
          clearData={clearData}
          getAllTheInformation={getAllTheInformation}
          defaultAccount={defaultAccount}
          userLatestIndex={userLatestIndex}
          minMld={minMld || 0}
          lordRatio={lordRatio}
          allowance={allowance}
          userBalance={userBalance}
          monthToSecData={monthToSecData}
          finalApyData={finalApyData}
          infoOpen={infoOpen}
          setInfoOpen={setInfoOpen}
          apyinfoOpen={apyinfoOpen}
          setApyinfoOpen={setApyinfoOpen}
          totalMLDStaked={totalMLDStaked}
          setTotalMLDStaked={setTotalMLDStaked}
        />
        {/* <FAQSection/> */}
      </Container>
    </Root>
  );
};

export default Farm;
